<script>
    import { useNavigate } from "svelte-navigator";
    import { onMount } from 'svelte';
    import { headerDisplayStore } from '../stores/General';
    import { videoDetailStore, videoEditStore } from '../stores/Video';
    import VideoEditOverlay from "./overlays/VideoEditOverlay.svelte";
   import Button from '../components/button/RouteButton.svelte';
    import Video from '../components/Video.svelte';
import CustomIcon from "../components/CustomIcon.svelte";
    const navigate = useNavigate();
    export let source = "";
    export let poster = "";

    let videoEdit = false;

    onMount(() => {
        headerDisplayStore.SetTitle('Video Details');
        source = $videoDetailStore.asset_url
        poster = $videoDetailStore.thumbnail_url
    });

    const edit = () => {
        videoEditStore.set($videoDetailStore);
        videoEdit = true
    }
</script>
<div class="w-full sm:px-6">
    <div class="py-2 md:py-2">
        <div class="sm:flex items-center justify-between">
            <div>
                <Button name="Go Back" route={-1} goback={true} />
    
            </div>
        </div>
    </div>
</div>

<div class="rounded mx-16 my-4">
    <div class="px-16 py-7 flex bg-white rounded-2xl justify-between">
        <div class="w-690 mx-1.5 grow-2">
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Video ID
                </div>
                <div class="text-xs pt-1">
                    {$videoDetailStore?.topper_id || '-'}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Video Title
                </div>
                <div class="text-xs pt-1">
                    {$videoDetailStore?.title || '-'}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Video Description
                </div>
                <div class="text-xs pt-1">
                    {$videoDetailStore?.description || '-'}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Video File
                </div>
                <div class="text-xs pt-1">
                    {$videoDetailStore.fileName || '-'}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    File Size
                </div>
                <div class="text-xs pt-1">
                    {$videoDetailStore.fileSize || '-'}
                </div>
            </div>

        </div>
        <div class="pt-28 flex justify-center z-0 shadow-sm rounded-md sm:shadow-none sm:space-x-6 grow-1"
        >
            <button
                type="button"
                on:click={() => edit()}
                class="w-72 h-14 relative inline-flex items-center justify-center px-1 py-2 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
            >
               

                <CustomIcon width="19" height="20" name="edit_cd"/>
                
                <span class="ml-4">Edit </span>
            </button>
        </div>
    </div>
    <div class="w-full flex justify-center">
        <div
        class="inline-block cursor-pointer align-bottom bg-white p-2 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full max-w-2xl sm:w-full"
        >
        <Video {source} {poster} />
        </div>
    </div>
    {#if videoEdit}
        <VideoEditOverlay
            onClose={() => {
                videoEdit = false;
            }}
        />
    {/if}
</div>
